<div class="modal-wrapper">
  <div class="add-filter-header modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <div>
      <button type="button" class="close" aria-label="Close" (click)="close(null)">
        <span aria-hidden="true">&times;</span>
      </button>
      <span class="resize" role="button" tabindex="0" aria-label="full screen" (click)="resize()" title="Toggle full width mode">
        <i class="material-icons" *ngIf="!isFullScreen"> fullscreen </i>
        <i class="material-icons" *ngIf="isFullScreen"> fullscreen_exit </i>
      </span>
    </div>
  </div>

  <div class="modal-body ey-add-filter-body" *ngIf="spinnerVisible">
    <div class="overlay">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div class="modal-header modal-secondary-header" *ngIf="showHeader && !spinnerVisible">
    <div class="container-fluid">
      <ng-content select="[header]"></ng-content>
    </div>
  </div>
  <div *ngIf="!spinnerVisible" class="modal-body ey-add-filter-body">
    <div class="container-fluid">
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
  <div *ngIf="!spinnerVisible" class="modal-footer ey-add-filter-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
